import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';

import './SideBar.scss';
import AppModeContext from 'src/containers/AppMode/AppMode.context';
import Betslip from '../Betslip/BetslipContainer';
import Filter from '../Filter/Filter';
import Icon from '../Icon/Icon';
import MatchTracker from '../MatchTracker/MatchTracker';
import { default as Banner } from 'src/components/Banner/BannerContainer/BannerContainer';
import { default as ContentTickertape } from 'src/components/ContentTickertape/ContentTickertape';

export const components = { Betslip, Filter, Banner, ContentTickertape };

class SideBar extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
      drawer: '',
      scrolled: 0
    };

    this.betslipChild = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.listenToScroll);
    this.listenToScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenToScroll);
  }

  listenToScroll = () => {
    const scrolled = document.body.scrollTop || document.documentElement.scrollTop;
    if (scrolled > 100 && this.state.scrolled < 100){
      this.setState({ scrolled });
    } else if (scrolled < 100 && this.state.scrolled > 100){
      this.setState({ scrolled });
    } else if (scrolled === 0){
      this.setState({ scrolled });
    }
  }

  handleClick = () => {
    const { RETAIL_MODE } = this.context;

    this.setState({ isOpen: !this.state.isOpen });
    window.dispatchEvent(new CustomEvent('resize'));
    this.props.changeSidebarCollapsed({ sidebar: this.props.sideBar, isRetail: RETAIL_MODE, width: window.innerWidth });
  }

  renderComponents = (type) => {
    const { drawer, scrolled } = this.state;
    const sideBar = type || this.props.sideBar;
    const { matchTracker } = this.props;
    let height = 150;

    if (scrolled > 100) {
      height = 160;
    } else if (this.asideRef && scrolled === 0) {
      height = Math.abs(0 - this.asideRef.getBoundingClientRect().top);
    }
    if (this.context.RETAIL_MODE) {
      height += 80;
    }

    return (
      <>
        {
          !drawer && this.props.template[sideBar].collapse &&
            <button
              onClick={ this.handleClick }
              className={
                classNames({
                  'sidebar__btn': true,
                  'sidebar__btn--close': this.props.template[sideBar].collapsed
                })
              }
            >
              <Icon
                icon={ sideBar === 'leftSideBar' ? 'menuClosedFilter' : 'menuClosedBetslip' }
                className="sidebar__menu"
              />
            </button>
        }
        <aside
          className={
            classNames({
              'sidebar': true,
              'sidebar--close': this.props.template[sideBar].collapsed,
              'sidebar__sticky': scrolled > 0,
              'sidebar__slip' : sideBar === 'rightSideBar'
            })
          }
          ref={ el => this.asideRef = el }
          style={ { height: `calc(100vh - ${ height }px)` } }
        >
          {
            sideBar === 'rightSideBar' && matchTracker.showMatchTracker && (
              <MatchTracker id={ matchTracker.eventId } showTitle />
            )
          }
          {
            this.props.template[sideBar].components &&
          this.props.template[sideBar].components.map((item, index) => {
            const MyComponent = components[item.type];
            const props = {};
            if (item === 'Betslip') {
              props.forwardRef = this.betslipChild;
            }

            return <MyComponent data={ item } key={ index + item } { ...props } />;
          })
          }
        </aside>
      </>
    );
  }

  render() {
    return (
      <>
        { this.props.sideBar !== 'bottomSideBar' && this.renderComponents() }
      </>
    );
  }
}

SideBar.contextType = AppModeContext;

SideBar.propTypes = {
  t: PropTypes.func,
  template: PropTypes.object,
  sideBar: PropTypes.string,
  onToggle: PropTypes.func,
  matchTracker: PropTypes.object,
  changeSidebarCollapsed: PropTypes.func
};

const mapState = state => ({
  template: state.content.template,
  matchTracker: state.events.matchTrackerSidebar
});

const mapDispatch = dispatch => ({
  changeSidebarCollapsed: (sidebar) => dispatch.content.changeSidebarCollapsed(sidebar)
});

export default connect(mapState, mapDispatch)(withTranslation('common')(SideBar));
